import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useEffect, useState } from 'react';
import styled from '@xstyled/styled-components';
import { Form, Checkbox, Spin, Space } from 'antd';
import { TextLinkButton, TextOptionInput } from '@lib/common';
import { BaseQuestionEdit } from '../base-question';
import { useForm } from 'antd/lib/form/Form';
import { styleVariables } from '@lib/common';
import { PlusCircleOutlined } from '@ant-design/icons';
import { QuestionFieldType } from '@module/form';
import { QuestionAnswerUploadedFilePreview } from '../../../../file-storage-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AnswerListField = styled(Form)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-form-item {\n    width: 100%;\n    margin-bottom: 0;\n  }\n"])));
var SpinLayout = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  margin-top: 16px;\n"])));
var AnswerItem = styled(Checkbox)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  .ant-checkbox + span {\n    width: 100%;\n    padding-right: 0;\n  }\n  .ant-input-affix-wrapper {\n    border-radius: 4px !important;\n    border-color: ", ";\n    padding: 0 11px 0 11px;\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background: ", ";\n  }\n  .ant-form-item {\n    margin-bottom: 0;\n  }\n"])), styleVariables.colors.gray8, styleVariables.colors.blue4);
var AnswerGroup = styled(Checkbox.Group)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var ButtonAddMoreAnswer = styled(TextLinkButton)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", " !important;\n  font-weight: 500;\n  cursor: pointer;\n  font-size: 14px;\n\n  &:hover {\n    opacity: 0.7;\n  }\n"])), styleVariables.colors.blue4);
var AddingIcon = styled(PlusCircleOutlined)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-right: 10px;\n"])));
var QuestionContentTitle = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 8px;\n"])));
var Content = styled(Space)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var InputArea = styled(Space)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var AnswerListFieldContainer = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: stretch;\n  align-items: center;\n\n  .ant-form-item {\n    margin-bottom: 0;\n    width: 100%;\n  }\n"])));
export var QuizEditStatus;

(function (QuizEditStatus) {
  QuizEditStatus[QuizEditStatus["EXECUTE"] = 1] = "EXECUTE";
  QuizEditStatus[QuizEditStatus["SUCCESS"] = 2] = "SUCCESS";
  QuizEditStatus[QuizEditStatus["ERROR"] = 3] = "ERROR";
  QuizEditStatus[QuizEditStatus["RESET"] = 4] = "RESET";
})(QuizEditStatus || (QuizEditStatus = {}));

var FileContainer = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  margin: 8px 0 0 24px;\n"])));
var AnswerPanel = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
export var MultipleChoiceEdit = function MultipleChoiceEdit(props) {
  var question = props.question,
      index = props.index,
      isDisabledInputs = props.isDisabledInputs,
      onDelete = props.onDelete,
      onUpdate = props.onUpdate,
      onUpdateCorrectAnswer = props.onUpdateCorrectAnswer,
      onUpdateAnswer = props.onUpdateAnswer,
      onDeleteAnswer = props.onDeleteAnswer,
      deleteAnswerStatus = props.deleteAnswerStatus,
      onResetDeleteAnswer = props.onResetDeleteAnswer,
      onCreateAnswer = props.onCreateAnswer,
      createAnswerStatus = props.createAnswerStatus,
      onResetCreateAnswer = props.onResetCreateAnswer,
      onUpdateType = props.onUpdateType,
      defaultDescription = props.defaultDescription,
      onShowingUploadAnswerFileModal = props.onShowingUploadAnswerFileModal,
      onDeleteAnswerFileModal = props.onDeleteAnswerFileModal;

  var _useForm = useForm(),
      _useForm2 = _slicedToArray(_useForm, 1),
      form = _useForm2[0];

  var getFieldValue = form.getFieldValue,
      setFieldsValue = form.setFieldsValue;

  var _useState = useState({}),
      isDeletingMap = _useState[0],
      setIsDeletingMap = _useState[1];

  var onFieldsChange = useCallback(function (e) {
    var _e = _slicedToArray(e, 1),
        infoChange = _e[0];

    if (!infoChange) return;
    var name = infoChange.name,
        value = infoChange.value;

    if (name.length <= 1) {
      var _name = _slicedToArray(name, 1),
          _field = _name[0];

      var _questionId = getFieldValue(QuestionFieldType.id);

      if (_field === QuestionFieldType.type) {
        onUpdateType(_questionId, value);
      }

      if (_field === QuestionFieldType.explanation) return;
      onUpdate(_questionId, _field, value);
    } else {
      var _name2 = _slicedToArray(name, 3),
          _index = _name2[1],
          _field2 = _name2[2];

      if (_field2 === QuestionFieldType.id) {
        var correctAnswerIdsUpdate = question.correctAnswers.map(function (a) {
          return a.answerId;
        });

        var _e2 = _slicedToArray(e, 1),
            option = _e2[0];

        var isIncluded = correctAnswerIdsUpdate.includes(value);

        if (isIncluded) {
          correctAnswerIdsUpdate = correctAnswerIdsUpdate.filter(function (answerId) {
            return answerId !== option.value;
          });
        } else {
          correctAnswerIdsUpdate.push(option.value);
        }

        onUpdateCorrectAnswer(correctAnswerIdsUpdate);
      } else if (value) {
        onUpdateAnswer(_index, _field2, value);
      }
    }
  }, [getFieldValue, onUpdate, onUpdateAnswer, onUpdateCorrectAnswer, onUpdateType, question]);
  useEffect(function () {
    if (deleteAnswerStatus === QuizEditStatus.SUCCESS) {
      deleteAnswerStatus && onResetDeleteAnswer();
    }

    if (createAnswerStatus === QuizEditStatus.SUCCESS) {
      createAnswerStatus && onResetCreateAnswer();
    }

    if (deleteAnswerStatus === QuizEditStatus.RESET) {
      setIsDeletingMap({});
    }

    setFieldsValue(question.toJsonObject()); // dependency optimized for performance DON'T CHANGE
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question, question.answers, deleteAnswerStatus]);

  var handleAnswerInputFocus = function handleAnswerInputFocus(inputValue, answerIndex) {
    var defaultAnswerText = "Nh\u1EADp c\xE2u tr\u1EA3 l\u1EDDi";
    var isDefaultAnswerText = inputValue === defaultAnswerText;

    if (isDefaultAnswerText) {
      var _form$getFieldsValue = form.getFieldsValue(),
          answers = _form$getFieldsValue.answers;

      answers[answerIndex].description = '';
      form.setFieldsValue({
        answers: answers
      });
    }
  };

  var handleAnswerInputBlur = function handleAnswerInputBlur(inputValue, answerIndex) {
    var isEmptyInputValue = !inputValue.length;

    if (isEmptyInputValue) {
      var _form$getFieldsValue2 = form.getFieldsValue(),
          answers = _form$getFieldsValue2.answers;

      var defaultAnswerText = "Nh\u1EADp c\xE2u tr\u1EA3 l\u1EDDi";
      answers[answerIndex].description = defaultAnswerText;
      form.setFieldsValue({
        answers: answers
      }); // onUpdateAnswer(answerIndex, 'description', defaultAnswerText);
    }
  };

  var renderAnswerFiles = function renderAnswerFiles(answer) {
    var hasFiles = answer && answer.files.length > 0;

    if (hasFiles) {
      return /*#__PURE__*/_jsx(FileContainer, {
        children: answer.files.map(function (file, index) {
          return /*#__PURE__*/_jsx(QuestionAnswerUploadedFilePreview, {
            fileId: file.id.toString(),
            signedUrl: file.url,
            type: file.type,
            size: file.size,
            questionId: question.id.toString(),
            answerId: answer.id.toString(),
            onClick: function onClick() {
              return onShowingUploadAnswerFileModal(question.id.toString(), answer.id.toString(), file);
            },
            onDelete: onDeleteAnswerFileModal
          }, index);
        })
      });
    }
  };

  return /*#__PURE__*/_jsx(Form, {
    form: form,
    name: "question-multiple-choice-form",
    initialValues: question.toJsonObject(),
    onFieldsChange: onFieldsChange,
    children: /*#__PURE__*/_jsx(BaseQuestionEdit, _objectSpread(_objectSpread({}, props), {}, {
      form: form,
      onUpdateExplanation: onUpdate,
      question: question,
      index: index,
      onDelete: onDelete,
      onUpdate: onUpdate,
      defaultDescription: defaultDescription,
      children: /*#__PURE__*/_jsxs(Content, {
        direction: "vertical",
        size: "small",
        children: [/*#__PURE__*/_jsx(QuestionContentTitle, {
          children: "Ch\u1ECDn \u0111\xE1p \xE1n \u0111\xFAng "
        }), /*#__PURE__*/_jsx(AnswerGroup, {
          defaultValue: question.correctAnswers.map(function (c) {
            return c.answerId;
          }),
          children: /*#__PURE__*/_jsx(AnswerListField.List, {
            name: "answers",
            children: function children(fields) {
              return /*#__PURE__*/_jsxs(InputArea, {
                direction: "vertical",
                size: "middle",
                children: [fields.map(function (field, index) {
                  var _isDeletingMap$field$;

                  var isDeleting = (_isDeletingMap$field$ = isDeletingMap[field.key]) !== null && _isDeletingMap$field$ !== void 0 ? _isDeletingMap$field$ : false;
                  return /*#__PURE__*/_jsx(AnswerListFieldContainer, {
                    children: /*#__PURE__*/_jsxs(AnswerPanel, {
                      children: [/*#__PURE__*/_jsx(AnswerListField.Item, {
                        name: [field.name, 'id'],
                        children: /*#__PURE__*/_jsx(AnswerItem, {
                          children: /*#__PURE__*/_jsx(AnswerListField.Item, {
                            name: [field.name, 'description'],
                            children: /*#__PURE__*/_jsx(TextOptionInput, {
                              disabled: isDisabledInputs,
                              onFocus: function onFocus(e) {
                                return handleAnswerInputFocus(e.target.value, index);
                              },
                              onBlur: function onBlur(e) {
                                return handleAnswerInputBlur(e.target.value, index);
                              },
                              placeholder: defaultDescription,
                              onDelete: function onDelete(e) {
                                e.stopPropagation();
                                onDeleteAnswer(field.key);
                                setIsDeletingMap(function (prevIsDeletingMap) {
                                  return _objectSpread(_objectSpread({}, prevIsDeletingMap), {}, _defineProperty({}, field.key, true));
                                });
                              },
                              isHiddenDelete: question.answers.length === 1,
                              isDeleting: isDeleting,
                              hasImage: question.answers[index] && question.answers[index].files.length > 0,
                              onShowingUploadImageModal: function onShowingUploadImageModal() {
                                return onShowingUploadAnswerFileModal(question.id.toString(), question.answers[index].id.toString());
                              }
                            })
                          })
                        })
                      }), renderAnswerFiles(question.answers[index])]
                    })
                  }, field.key);
                }), createAnswerStatus && createAnswerStatus !== QuizEditStatus.RESET && /*#__PURE__*/_jsx(SpinLayout, {
                  children: /*#__PURE__*/_jsx(Spin, {})
                })]
              });
            }
          })
        }), /*#__PURE__*/_jsxs(ButtonAddMoreAnswer, {
          onClick: onCreateAnswer,
          children: [/*#__PURE__*/_jsx(AddingIcon, {}), "Th\xEAm \u0111\xE1p \xE1n"]
        })]
      })
    }))
  });
};